module.exports = __webpack_public_path__ + "assets/32130ded785a10547add72a61bbb17af.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-Light.woff
 ** module id = 1736
 ** module chunks = 1
 **/